import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";

export class PooledBenchmarkUnivService extends BaseService {
  burgissCalcPooledBenchmarkIRRByWeight(
    universe: string = null,
    weight: string = null,
    currency?: string,
    alternateCurrrency?: string,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      weight,
      null,
      currency,
      alternateCurrrency,
      startDate,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.IRR,
      uniqueCellId,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkIRRByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.PooledbenchmarkUniv
    );
  }
  burgissCalcPooledBenchmarkTWRRByWeight(
    universe: string = null,
    weight: string = null,
    currency?: string,
    alternateCurrrency?: string,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string,
    dynamicParameter?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      weight,
      null,
      currency,
      alternateCurrrency,
      startDate,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.TWRR,
      uniqueCellId,
      dynamicParameter
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkTWRRByWeight",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.PooledbenchmarkUniv
    );
  }
  BurgissCalcPooledBenchmarkIRRByCommitment(
    universe: string = null,
    commitment: string = null,

    currency?: string,
    alternateCurrrency?: string,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      null,
      commitment,
      currency,
      alternateCurrrency,
      startDate,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.IRR,
      uniqueCellId,
      null
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkIRRByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.PooledbenchmarkUniv
    );
  }
  burgissCalcPooledBenchmarkTWRRByCommitment(
    universe: string = null,
    commitment: string = null,
    currency?: string,
    alternateCurrrency?: string,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    uniqueCellId?: string,
    dynamicParameter?: string
  ) {
    const objRequest = this.createPayload(
      universe,
      null,
      commitment,
      currency,
      alternateCurrrency,
      startDate,
      endDate,
      weightingMethod,
      requireReportedValuation,
      MeasuresType.TWRR,
      uniqueCellId,
      dynamicParameter
    );
    return super._pushOperation(
      "BurgissCalcPooledBenchmarkTWRRByCommitment",
      objRequest,
      this.APICONFIG.GETPORTFOLIOBENCHMARKUNIV,
      FunctionGroup.PooledbenchmarkUniv
    );
  }

  createPayload(
    universe: string = null,
    weight: string = null,
    commitment: string = null,
    baseCurrency?: string,
    alternateCurrrency?: string,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    requireReportedValuation?: any,
    measure: string = null,
    alias: string = null,
    dynamicParameter: any = null
  ) {
    const minAndMaxDateObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: "-1",
      portfolioID: "0",
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(baseCurrency).toLowerCase() === "true",
      alternateBaseCurrency: alternateCurrrency,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: startDate,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: "i",
      selectionsetID: "",
      assetID: null,
      weightingMethod: weightingMethod,
      value: null,
      filter: "",
      attributeName: null,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: requireReportedValuation,
      alias: alias,
      currencyHedgesetId: "",
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: dynamicParameter,
      universe: universe,
      weight: String(weight).toUpperCase() == "NULL" ? "" : String(weight),
      commitment: String(commitment).toUpperCase() == "NULL" ? "" : String(commitment),
    };
    return minAndMaxDateObject;
  }
}
